import * as React from 'react';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { SERVER_URL } from '../constants';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box } from '@mui/material';

const initialValue = dayjs();

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  const isSelected =
    !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;

  return (
    <Badge
      key={props.day.toString()}
      overlap="circular"
      badgeContent={isSelected ? <AccessTimeIcon sx={{ color: 'darkgrey', fontSize: 18 }} /> : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
  
    </Badge>
  );
}

export default function SchedulesCalendarControl(props) {

  React.useEffect(() => {
    props.fetchSchedulesList(initialValue);
    // abort request on unmount
    return () => requestAbortController.current?.abort();
  }, []);
  
  const requestAbortController = React.useRef(null);

  const handleMonthChange = (date) => {
    if (requestAbortController.current) {
      // make sure that you are aborting useless requests
      // because it is possible to switch between months pretty quickly
      requestAbortController.current.abort();
    }

    props.setIsLoading(true);
    props.setHighlightedDays([]);
    props.fetchSchedulesList(date);
  };

  const [currentView, setCurrentView] = useState('day');

  const handleViewChange = (newView) => {
    setCurrentView(newView);
  };

  const handleDateChange = (newDate) => {
    if (currentView === 'day') {
      console.log('User clicked a day:', newDate);
    } else if (currentView === 'year') {
      console.log('User clicked a year:', newDate.year());
    } else {
      console.log('User clicked something else:', newDate);
    }
  };


  const handleDayClick = (selectedDate) => {
    // console.log('A day was clicked! New value:', selectedDate.format('YYYY-MM-DD'));
    const selected = props.schedules.find(schedule => schedule.date === selectedDate.format('YYYY-MM-DD'));
    const today = dayjs().startOf('day'); // normalize to midnight
    const isPastDate = selectedDate.isBefore(today, 'day');
    if (currentView === 'day') {
        if (selected) {
          props.setSelectedSchedule(selected);
        } else {
          if (!isPastDate)
          {
            props.setNewScheduleData({
              date: selectedDate.format('YYYY-MM-DD'),
              office_id: props.officeId
            });
          }
        }
    } else {
      props.fetchSchedulesList(selectedDate);
    }
  };


  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        
        <DateCalendar
          sx={{ width: '100%', overflowX: 'hidden', mx: 'auto' }}
          defaultValue={initialValue}
          loading={props.isLoading}
          onMonthChange={handleMonthChange}
          onViewChange={handleViewChange}
          onChange={handleDayClick}
          renderLoading={() => <DayCalendarSkeleton />}
          slots={{
            day: ServerDay,
          }}
          slotProps={{
            day: {
              highlightedDays: props.highlightedDays,
            },
          }}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
}